export default __webpack_public_path__ + "locales/ja-JP/Settings.json?hash=3ac86df08fb7493bbf540e4921dd41b2";